const calcHeight = () => {
    const membershipCards = document.querySelectorAll(".gh-tier-card");

    if (membershipCards.length && window.innerWidth > 1100) {
        const cardsDescriptions = document.querySelectorAll(
            ".gh-tier-card__desc"
        );
        let maxHeight = 0;

        // Reset heights before measuring to get natural size
        cardsDescriptions.forEach((desc) => {
            desc.style.height = '';
        });

        cardsDescriptions.forEach((desc) => {
            if (desc.clientHeight >= maxHeight) {
                maxHeight = desc.clientHeight;
            }
        });

        cardsDescriptions.forEach((desc) => {
            desc.style.height = `${maxHeight}px`;
        });
    } else {
        // Below breakpoint — clear forced heights
        const cardsDescriptions = document.querySelectorAll(".gh-tier-card__desc");
        cardsDescriptions.forEach((desc) => {
            desc.style.height = '';
        });
    }
};

let resizeTimer;
const onResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(calcHeight, 150);
};

if (document.querySelectorAll('.gh-tier-card').length) {
    window.addEventListener('resize', onResize);
}

export { calcHeight };
